import React from 'react'
import { Breadcrumb as BSBreadcrumb } from 'react-angle-dashboard-components'

export interface IBreadcrumb {
  link: string
  title: string
}
export interface IBreadcrumbProps {
  breadcrumbs: IBreadcrumb[]
}
const Breadcrumb: React.FC<IBreadcrumbProps> = ({ breadcrumbs }) => {
  return (
    <BSBreadcrumb>
      {breadcrumbs.length ? (
        breadcrumbs.map((crumb: any, key) => (
          <BSBreadcrumb.Item
            href={crumb.link}
            key={`${crumb.name}-${crumb.link}`}
            active={breadcrumbs.length === key + 1}
            className="fs-16"
          >
            <span className="text-capitalize">{crumb.title}</span>
          </BSBreadcrumb.Item>
        ))
      ) : (
        <BSBreadcrumb.Item className="fs-16" href="/">
          Home
        </BSBreadcrumb.Item>
      )}
    </BSBreadcrumb>
  )
}

export default Breadcrumb
